import Vue from "vue";
import VueRouter from "vue-router";
import NewLayout from "../views/NewLayout/Layout";
import { trackTimeSpent } from "@/utils/posthogHelpers";
import {
  checkAccess,
  clearCookies,
  getToken,
  checkTokenExpiry,
  getMobileToken,
} from "../utils/tokenCheck.js";
import { appConfig } from "@/config/appConfig";
Vue.use(VueRouter);

const routes = [
  {
    path: "/register/:courseID",
    name: "Register",
    component: () => import("@/components/modals/RegisterModal.vue"),
    meta: {
      title: "Register",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/LoginPage.vue"),
  },
  {
    path: "/",
    component: NewLayout,
    redirect: "/dashboard",
    meta: {
      title: "Dashboard",
    },
    children: [
      {
        path: "/tc/:certificateCode",
        name: "PublicCertificate",
        component: () => import("../routings/PublicCertificate.vue"),
        meta: {
          title: "Certificate",
          isSidebarComponent: true,
          isPublic: true,
        },
      },
      {
        path: "marketplace",
        name: "MarketPlace",
        component: () =>
          import("../views/TrainingFolder/MarketPlace/MarketPlace.vue"),
        meta: {
          title: "Marketplace",
          isSidebarComponent: true,
          isPublic: true, // Mark as public route
        },
      },
      {
        path: "filteredcoursesview",
        name: "FilteredCoursesView",
        component: () =>
          import("../views/TrainingFolder/FilteredCoursesView.vue"),
        meta: {
          title: "All Courses",
          isPublic: true,
        },
      },
      {
        path: "coursedetail/:courseID",
        name: "CourseDetail",
        component: () =>
          import("../views/TrainingFolder/CourseDetail/CourseDetail.vue"),
        meta: {
          title: "Course Detail",
          isPublic: true, // Mark as public route
        },
      },
      {
        path: "courseview/:courseID",
        name: "CourseView",
        component: () =>
          import("../views/TrainingFolder/Course/CourseView.vue"),
        meta: {
          title: "Course Detail",
        },
      },
      {
        path: "community",
        name: "CommunityView",
        component: () =>
          import("../views/TrainingFolder/Community/CommunityView.vue"),
        meta: {
          title: "Community",
          isSidebarComponent: true,
        },
      },
      {
        path: "review/:courseID",
        name: "Review",
        component: () => import("../views/TrainingFolder/Reviews/Review.vue"),
        meta: {
          title: "Reviews",
        },
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () =>
          import("../views/TrainingFolder/Dashboard/Dashboard.vue"),
        meta: {
          title: "Dashboard",
          isSidebarComponent: true,
        },
      },
      {
        path: "notifications",
        name: "notifications",
        component: () => import("../components/Notifications.vue"),
        meta: {
          title: "notifications",
        },
      },
      {
        path: "instructor",
        name: "Instructor",
        component: () => import("../routings/Instructor.vue"),
        meta: {
          title: "Instructor",
        },
      },
      {
        path: "instructors",
        name: "Instructors",
        component: () =>
          import(
            "../views/TrainingFolder/CourseDetail/components/InstructorLandingpage.vue"
          ),
        meta: {
          title: "Instructors",
          isSidebarComponent: true,
        },
      },
      {
        path: "certificate",
        name: "Certificate",
        component: () =>
          import("../views/TrainingFolder/Certificates/Certificate.vue"),
        meta: {
          title: "Certificate",
          isSidebarComponent: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/training",
  routes,
});

export default router;

// To avoid Duplicate Navigation
const onError = (e) => {
  // avoid NavigationDuplicated
  if (e.name !== "NavigationDuplicated") throw e;
};

// keep original function
const _push = router.__proto__.push;
// then override it
router.__proto__.push = function push(...args) {
  try {
    const op = _push.call(this, ...args);
    if (op instanceof Promise) op.catch(onError);
    return op;
  } catch (e) {
    onError(e);
  }
};
const title = "Candidate Portal";

const getPageTitle = (pageTitle) => {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
};
let pageStart = Date.now();

const publicPages = [
  "PublicCertificate",
  "CourseDetail",
  "FilteredCoursesView",
  "MarketPlace"
]
router.beforeEach((to, from, next) => {
  document.title = getPageTitle(to.meta.title);
  const redirectUrl = getMobileToken() ? `${appConfig.candidateBase}/login` : `${appConfig.websiteBase}/login`;
  if (publicPages.includes(to.name)) {
    next();
  } else if (checkAccess()) {
    const hasToken = getToken();
    const expiryTime = checkTokenExpiry();
    if (hasToken && expiryTime) {
      next();
    } else {
      clearCookies();
      // location.replace("http://localhost:8080/login");
      location.replace(redirectUrl);
    }
  } else {
    clearCookies();
    // location.replace("http://localhost:8080/login");
    location.replace(redirectUrl);
  }

  if (from.fullPath) {
    const timeSpent = Math.round((Date.now() - pageStart) / 1000);
    trackTimeSpent({
      timeSpent: timeSpent,
      page: from.name
    })
  }
});
